import { render } from "./ViewUsers.vue?vue&type=template&id=2c37a4a1&scoped=true"
import script from "./ViewUsers.vue?vue&type=script&lang=js"
export * from "./ViewUsers.vue?vue&type=script&lang=js"

import "./ViewUsers.vue?vue&type=style&index=0&id=2c37a4a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c37a4a1"]])

export default __exports__